import React from 'react';
import SearchInput from "components/MainApp/atoms/Filters/SearchSimple";

import styles from "./MainApp.organisms.Filters.SimpleSearchPanel.module.scss";

const SimpleSearchPanel = ({ placeholder, handleSubmit, valueSearch = "" }) => {

    return <div className={styles["simple-search-panel"]}>
            <SearchInput placeholder={placeholder} handleSubmit={handleSubmit} valueSearch={valueSearch}/>
        </div>
}

export default SimpleSearchPanel;